import { DefaultEntity } from "../../../@types/entity/default-entity";
import { EntityField } from "../../../@types/entity/field/crud/field-crud-entity";
import { Footer } from "components/footer/footer-component";
import HeaderCrud from "components/header/header-crud-component";
import { Loading } from "components/loading/loading-component";
import { useCallback, useEffect, useMemo, useState, useRef } from "react";
import { Button, Card, Col, Collapse, Container, Form, Modal, Row, Table } from "react-bootstrap";
import CreateTableCrud from "components/table/table-crud-component";
import { ModalCrud } from "components/modal/modal-crud-component";
import CreateFieldModalCrud from "components/field/field-modal-component";
import { TableHeaderFixedStyled } from "pages/style/table/table-header-fixed-styled";
import { ParseDateToBrWithHours } from "helper/format-date-helper";
import Select from 'react-select'
import { TableComponents } from "../../../@types/entity/interface/table-interface";
import { formatDate, formatarDataComHora } from 'domain/commons/format-date';
import { AiOutlineDelete } from "react-icons/ai";
import { useLoader } from "components/loader/loader-context";
import { PerfilEmpresa } from "../../../@types/interfaces/safety/perfil-empresa";
import { PerfilUsuario, PerfilUsuarioInsert } from "../../../@types/interfaces/safety/perfil-usuario";
import { getEnv } from "helper/window-helper";
import { UseAlert } from "hook/alert-hook";
import { RestUseCase, ServiceOperationResult } from "service/api/rest/rest-usecase";
import { SimpleCompany } from "../../../@types/interfaces/communs/simple-companies"
import { UsuarioDTO } from "../../../@types/interfaces/safety/usuario-dto"
import { BsSearch } from 'react-icons/bs';
import ReactTooltip from 'react-tooltip';
import { VinculosCompraBotao, VinculosCompraModal } from './components/vinculos-compra-component';

interface CrudRestUserInterface<T> {
    create: (model?: T, profile?: string[]) => void
    edit: (model?: T, profile?: string[]) => Promise<boolean>
    block: (value?: any) => void
    unblock: (value?: any) => void
    getById(id?: any, value?: any): void
    listAllByCompany: (value?: any) => void
    getUsuariosPorEmpresaENome: (
        empIntCod: number,
        nome: string
    ) => Promise<T[] | null>;
    copyProfile: (idFrom: number, idTo: number) => void
    handleListLogUser: (dateInit: string, dateEnd: string) => Promise<any>
    resetPassword: (params: { userEmail: string, userLogin?: string }) => void
}


type Props = {
    titlePage: string
    entityFields: EntityField[]
    tableComponents: TableComponents
    userCompanyID: any
    companies: any[]
    profile: any[]
    canManagePurchaseLinks: boolean
    modelMethods: CrudRestUserInterface<DefaultEntity>;
}

const checkboxValues = ["ADMIN", "CONSULTOR", "SUPORTE", "DESENVOLVEDOR", "GUEST", "COMPRAS_GESTOR", "COMPRAS_OPERACIONAL", "SCRAP_ADMINISTRADOR", "SCRAP_COMPRADOR", "SCRAP_AUDITOR", "SCRAP_CONSULTOR", "SCRAP_FINANCEIRO", "SCRAP_VENDAS"]

const UserPageV2: React.FC<Props> = ({ titlePage, entityFields, tableComponents, userCompanyID, companies, profile, canManagePurchaseLinks, modelMethods }: Props) => {

    const { showLoader, hideLoader } = useLoader();

    const ENDPOINT_PERFIS = getEnv("REACT_APP_END_POINT_PERFIS")!
    //Recebe os perfis por empresa
    const [perfisEmpresa, setPerfisEmpresa] = useState<PerfilEmpresa[]>([]);
    //Guarda o perfil selecionado
    const [perfilSelecionado, setPerfilSelecionado] = useState<PerfilEmpresa | null>(null);
    //Guarda as datas do perfil
    const [validadeDe, setValidadeDe] = useState<string | null>(null);
    const [validadeAte, setValidadeAte] = useState<string | null>(null);

    //Guarda os perfis do usuário
    const [perfisUsuario, setPerfisUsuario] = useState<PerfilUsuario[]>([]);

    /**  LOADING **/
    const [loading, updateLoading] = useState<boolean>(false)
    /** ENTIDADE PARA A TABELA E MODAL */
    const [entity, updateEntity] = useState(entityFields)

    /** VERIFICA SE ESTA EDITANDO */
    const [inEditing, updateInEditing] = useState<boolean>(true)

    /** ID DA EMPRESA SELECIONADA */
    const [companyID, updateCompanyID] = useState<number>(userCompanyID)
    useMemo(() => {
        updateCompanyID(userCompanyID)
    }, [userCompanyID])

    /** ESTADOS CHECkBOX PERFIS */
    const [checkedState, setCheckedState] = useState(
        new Array(checkboxValues.length).fill(false)
    );

    // Estado para controlar a exibição da modal para vincular perfil
    const [showModalVincularPerfil, setShowModalVincularPerfil] = useState(false);

    // Estado para controlar a exibição da modal para clonar perfil
    const [showModalClonarPerfil, setShowModalClonarPerfil] = useState(false);
    const [localizarUsuario, setLocalizarUsuario] = useState<string>('');
    const [usuariosEncontrados, setUsuariosEncontrados] = useState<UsuarioDTO[]>([]);

    const [comanieSelectedClonarPerfil, setComanieSelectedClonarPerfil] = useState<SimpleCompany | null>(null);

    // Estados para modal de restrições
    const [showModalRestricoes, setShowModalRestricoes] = useState(false);
    const [objetos, setObjetos] = useState<Array<{ id: number, descricao: string }>>([]);
    const [objetoSelecionado, setObjetoSelecionado] = useState<{ value: number, label: string } | null>(null);
    const [incluir, setIncluir] = useState<boolean>(false);
    const [alterar, setAlterar] = useState<boolean>(false);
    const [consultar, setConsultar] = useState<boolean>(false);
    const [excluir, setExcluir] = useState<boolean>(false);
    const [restricoesUsuario, setRestricoesUsuario] = useState<any[]>([]);
    const [isLoadingRestricoes, setIsLoadingRestricoes] = useState<boolean>(false);
    // Novos estados para módulo
    const [modulos, setModulos] = useState<Array<{ id: number, descricao: string, sigla: string }>>([]);
    const [moduloSelecionado, setModuloSelecionado] = useState<{ value: number, label: string } | null>(null);

    /** ATUALIZA ESTADOS PERFIS */
    useEffect(() => {
        profileChecked()
    }, [profile])

    /** MODAL */
    const [showModalCrud, updateShowModalCrud] = useState<boolean>(false)
    /** Modal de vínculos fica aqui (fora de ContainerTableCollapse, que é remontado a cada render) para não fechar ao exibir alertas. */
    const [showVinculos, updateShowVinculos] = useState<boolean>(false)
    const openModalCrud = () => { updateShowModalCrud(true) }
    const closeModalCrud = () => { updateShowModalCrud(false); modelMethods.listAllByCompany(companyID); updateLoading(false) }

    /** MUDA OS VALORES DOS CAMPOS */
    const changeField = (modelFields: any) => { updateEntity(modelFields) }

    /** BUSCA ID DO USUARIO DO MODAL */
    const searchEntityId = () => { return entity.filter((value) => value.name === "id")[0].valueField as number }

    /** BUSCA STATUS DO USUARIO DO MODAL (B = Bloqueado, N = Normal, Não mapeado: E, S) */
    const searchEntityStatus = () => { return entity.filter((value) => value.name === "status")[0].valueField as string }

    const inputRef = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, [localizarUsuario]);

    /** CLICA NA TABELA E ABRE O MODAL */
    const onClickTable = async (id: number) => {
        updateInEditing(true)
        await modelMethods.getById(id)
        openModalCrud()
    }

    /** CLICA EM NOVO */
    const onClickNew = () => {
        profile = []
        profileChecked()
        updateInEditing(false)
        clearFields()
        openModalCrud()
    }

    /** LIMPA OS CAMPOS */
    const clearFields = () => {
        updateEntity(entityFields.map(value => {
            if (value.name !== "idEmpresa") {
                value.valueField = ""
            }
            return value
        }))
    }

    /** CRIA USUÁRIO */
    const onSubmitForm = async () => {
        updateLoading(true)
        let model: any = {}
        entity.forEach((value) => { model[value.name] = value.valueField })
        model['roles'] = profile;
        await modelMethods.create(model, profile)
        closeModalCrud()
    }

    /** EDITA USUÁRIO */
    const onEditUser = async () => {
        updateLoading(true)
        let model: any = {}
        entity.forEach((value) => { model[value.name] = value.valueField })
        model['roles'] = profile;
        const wasEdited = await modelMethods.edit(model, profile)

        if (wasEdited) {
            closeModalCrud()
            return
        }

        updateLoading(false)
    }

    /** BLOQUEIA USUÁRIO */
    const blockUser = async () => {
        updateLoading(true);
        await modelMethods.block(searchEntityId());
        closeModalCrud()
    }

    /** DESBLOQUEIA USUÁRIO */
    const unblockUser = async () => {
        updateLoading(true);
        await modelMethods.unblock(searchEntityId());
        closeModalCrud()
    }

    /** RESETA SENHA */
    const onPasswordReset = async () => {
        updateLoading(true)
        var email = entity.filter((value) => value.name === "email")[0].valueField as string
        var login = entity.filter((value) => value.name === "login")[0].valueField as string
        await modelMethods.resetPassword({ userEmail: email, userLogin: login })
        closeModalCrud()
    }

    /** SELECT EMPRESA */
    const handleOnChangeSelect = useCallback((company: any) => {
        modelMethods.listAllByCompany(company.value)
        updateCompanyID(company.value)
    }, [])

    const CompaniesList = () => {
        let optionSelected
        companies?.forEach(company => {
            if (company.value === companyID) {
                optionSelected = company
            }
        })

        return (
            <>
                <div style={{ marginBottom: "5px" }}>
                    <Form.Label className="m-1">Empresa:</Form.Label>
                    <Select options={companies} defaultValue={optionSelected}
                        onChange={(company) => {
                            handleOnChangeSelect(company);
                        }} />
                </div>
            </>
        )
    }

    const CompaniesListFull = () => {
        let optionSelected
        companies?.forEach(company => {
            if (company.value === companyID) {
                optionSelected = company
            }
        })

        return (
            <>
                <div style={{ marginBottom: "5px" }}>
                    <Form.Label className="m-1">Empresa:</Form.Label>
                    <Select options={companies} defaultValue={optionSelected}
                        isDisabled={inEditing}
                        onChange={(company) => {
                            handleOnChangeSelect(company);
                        }} />
                </div>
            </>
        )
    }

    const handleOnChangeSelectCompaniesClonarPerfil = (company: any) => {
        const simpleCompany: SimpleCompany = {
            id: company.value,
            nome: company.label
        };

        setComanieSelectedClonarPerfil(simpleCompany);
    }

    const CompaniesListClonarPerfil = () => {
        return (
            <>
                <div style={{ marginBottom: "5px" }}>
                    <Form.Label className="m-1">Empresa:</Form.Label>
                    <Select
                        options={companies}
                        value={comanieSelectedClonarPerfil ? { value: comanieSelectedClonarPerfil.id, label: comanieSelectedClonarPerfil.nome } : null} //  Adicione value aqui
                        isDisabled={false}
                        onChange={(company) => {
                            handleOnChangeSelectCompaniesClonarPerfil(company);
                        }}
                    />
                </div>
            </>
        )
    }

    const clonarPerfil = () => {
        const idField = entityFields.find((field) => field.name === "id");
        setShowModalClonarPerfil(true);
        setComanieSelectedClonarPerfil(null);
        setUsuariosEncontrados([]);
        setLocalizarUsuario('');
    }

    // Função de clonagem recebe o id do usuário diretamente
    const OnClickEfetivarClonagem = async (usuarioId: number) => {
        showLoader();
        try {
            const idToString = entity.filter((value) => value.name === "id")[0].valueField as string;
            const idTo = parseInt(idToString, 10);

            if (!isNaN(idTo) && usuarioId != null) {
                await modelMethods.copyProfile(usuarioId, idTo);
                // opcional: showAlert de sucesso
            } else {
                console.error("ID inválido ou id do usuário não informado.");
            }
        } catch (err) {
            console.error("Erro ao clonar perfil:", err);
        } finally {
            hideLoader();
        }
    };

    const onClickBuscarUsuario = async () => {
        showLoader();

        if (!comanieSelectedClonarPerfil || !comanieSelectedClonarPerfil.id || !localizarUsuario) {
            showAlert({
                show: true,
                content: "Selecione uma empresa.",
                color: "warning",
                time: 2000
            });
            hideLoader();
            return;
        }

        try {

            const usuarios = await modelMethods.getUsuariosPorEmpresaENome(
                comanieSelectedClonarPerfil.id,
                localizarUsuario
            );

            if (usuarios && usuarios.length > 0) {
                setUsuariosEncontrados(usuarios as UsuarioDTO[]);
            } else {
                showAlert({
                    show: true,
                    content: "Nenhum usuário encontrado",
                    color: "warning",
                    time: 5000
                });
                setUsuariosEncontrados([]);
            }
        } catch (error) {
            console.error("Erro na busca:", error);
            showAlert({
                show: true,
                content: "Falha na conexão com o servidor",
                color: "danger",
                time: 5000
            });
        }

        hideLoader();
    };

    const InputBuscarUsuario = () => {
        return (
            <>
                <Form.Label className="mb-1">Nome ou parte do nome do usuário de origem:</Form.Label>
                <div className="d-flex align-items-center" key="search-container">
                    <Form.Control
                        ref={inputRef}
                        type="text"
                        placeholder="Pesquisar nome do usuário"
                        className="me-2"
                        value={localizarUsuario}
                        onChange={(e) => setLocalizarUsuario(e.target.value)}
                    />
                    <Button
                        variant="outline-secondary"
                        data-tip="Buscar usuário"
                        data-for="buscarUsuarioTooltip"
                        onClick={onClickBuscarUsuario}
                    >
                        <BsSearch />
                    </Button>
                    <ReactTooltip
                        id="buscarUsuarioTooltip"
                        place="bottom"
                        effect="solid"
                        backgroundColor="#6c757d"
                        textColor="white"
                    />
                </div>
            </>
        )
    }

    // Criação do componente LoginText inline
    const LoginText = () => {
        const loginField = entityFields.find((field) => field.name === "login");
        const [loginValue, setLoginValue] = useState<string>(loginField?.valueField || "");

        useEffect(() => {
            if (loginField) {
                setLoginValue(loginField.valueField); // Inicializa o valor do input
            }
        }, [loginField]);

        return (
            <div style={{ marginBottom: "5px" }}>
                <Form.Label className="m-1">{loginField?.labelField}</Form.Label>
                <input
                    type="text"
                    value={loginValue}
                    disabled={inEditing} // Desabilitar se em edição
                    required={loginField?.required || false}
                    className="form-control"
                    style={{ width: "50%" }}
                />
            </div>
        );
    };

    // Criação do componente NomeText inline
    const NomeText = () => {
        const nomeField = entityFields.find((field) => field.name === "nome");
        const [nomeValue, setNomeValue] = useState<string>(nomeField?.valueField || "");

        useEffect(() => {
            if (nomeField) {
                setNomeValue(nomeField.valueField); // Inicializa o valor do input
            }
        }, [nomeField]);

        return (
            <div style={{ marginBottom: "5px" }}>
                <Form.Label className="m-1">{nomeField?.labelField}</Form.Label>
                <input
                    type="text"
                    value={nomeValue}
                    disabled={inEditing} // Desabilitar se em edição
                    required={nomeField?.required || false}
                    className="form-control"
                />
            </div>
        );
    };

    const { showAlert } = UseAlert()

    // Criação do componente ProfileList inline
    const ProfileList = () => {
        let optionSelected: PerfilEmpresa | undefined; // Tipando corretamente como PerfilEmpresa ou undefined
        perfisEmpresa?.forEach(perfil => {
            if (perfil.id === perfilSelecionado?.id) {
                optionSelected = perfil;
            }
        });

        return (
            <>
                <div style={{ marginBottom: "5px" }}>
                    <Form.Label className="m-1">Perfil:</Form.Label>
                    <Select
                        options={perfisEmpresa.map(perfil => ({
                            value: perfil.id,
                            label: perfil.descricao,
                        }))}
                        value={optionSelected ? { value: optionSelected.id, label: optionSelected.descricao } : null}
                        onChange={(selectedOption) => {
                            handleOnChangePerfilSelect(selectedOption);
                        }}
                    />
                </div>
            </>
        );
    }


    const handleOnChangePerfilSelect = (selectedOption: any) => {
        setPerfilSelecionado({
            id: selectedOption.value,
            descricao: selectedOption.label,
        });
    };



    /** PERFIL */
    function profileChecked() {
        const updatedCheckedState = checkedState.map((checkedValue, index) => {
            if (profile.includes(checkboxValues[index])) {
                return checkedValue = true
            } else {
                return checkedValue = false
            }
        })
        setCheckedState(updatedCheckedState)
    }

    function addRemoveProfile(e: any, indexProfile: number) {
        if (!profile.includes(e.target.value)) {
            profile.push(e.target.value)
        } else {
            profile.splice(profile.indexOf(e.target.value), 1)
        }
        profileChecked()
    }

    function verLogAcesso() {
        alert("verLogAcesso");
    }

    // Função para abrir a modal que vincula perfil
    const vincularPerfil = () => {
        const idField = entityFields.find((field) => field.name === "id");

        if (idField) {
            listPerfisUsuario(idField.valueField).then(() => {
                setShowModalVincularPerfil(true);
            });
        }

        listPerfisEmpresa().then(() => {
            setShowModalVincularPerfil(true);
        });
    };

    async function listPerfisUsuario(idUsuario: number): Promise<void> {
        const query = `/usuario/${idUsuario}`;

        try {
            const response = await new RestUseCase(ENDPOINT_PERFIS + query).Get_<ServiceOperationResult<PerfilUsuario[]>>();

            if (response.success && Array.isArray(response.data)) {
                setPerfisUsuario(response.data);
            } else {
                console.warn("Erro ao buscar perfis:", response.errors);
                setPerfisUsuario([]);
            }
        } catch (error) {
            console.error("Erro ao buscar perfis da empresa:", error);
            showAlert({
                show: true,
                content: "Ops!!! Algo deu errado, tente novamente mais tarde...",
                color: "danger",
                time: 5000
            });
        }
    }


    async function listPerfisEmpresa(): Promise<void> {
        const query = '/empresa/' + companyID;
        try {
            const response = await new RestUseCase(ENDPOINT_PERFIS + query).Get();

            if (response.statusCode !== 500 && response.statusCode !== undefined) {
                // Mapeia o retorno corretamente para um array de PerfilEmpresa
                const perfisEmpresa: PerfilEmpresa[] = response.body.map((value: any) => ({
                    id: value.id,
                    descricao: value.descricao,
                }));

                setPerfisEmpresa(perfisEmpresa);
            }
        } catch (error) {
            console.error("Erro ao buscar perfis da empresa:", error);
        }
    }


    // Função para fechar a modal que vincula perfil
    const closeModalVincularPerfil = () => {
        setShowModalVincularPerfil(false);
    };

    // Função para fechar a modal que clona perfil
    const closeModalClonarPerfil = () => {
        setShowModalClonarPerfil(false);
        setLocalizarUsuario('');
        setUsuariosEncontrados([]);
        setComanieSelectedClonarPerfil(null);
    }

    //Função para vincluar o perfil
    const handleVincular = () => {
        if (!validadeDe) {
            showAlert({
                show: true,
                content: "A validade de início é obrigatória",
                color: "danger",
                time: 5000
            });
            return;
        }
        if (!validadeAte) {
            showAlert({
                show: true,
                content: "A validade de fim é obrigatória",
                color: "danger",
                time: 5000
            });
            return;
        }

        // Verifica se validadeAte é maior que validadeDe
        if (validadeAte && new Date(validadeAte) <= new Date(validadeDe)) {
            showAlert({
                show: true,
                content: "A validade até não pode ser anterior ou igual à validade de início.",
                color: "danger",
                time: 5000
            });
            return;
        }

        // Verifica se perfilSelecionado é null ou undefined
        if (!perfilSelecionado || !perfilSelecionado.id) {
            showAlert({
                show: true,
                content: "Você deve selecionar um perfil.",
                color: "danger",
                time: 5000
            });
            return;
        }

        const idField = entityFields.find((field) => field.name === "id");
        let idUsuario = 0;

        if (idField) {
            idUsuario = idField.valueField;
        }

        // Cria o objeto do tipo PerfilUsuarioInsert
        const perfilUsuarioInsert: PerfilUsuarioInsert = {
            usuarioId: idUsuario,
            perfilId: perfilSelecionado?.id || 0,
            dataInicio: formatarDataComHora(validadeDe),
            dataFim: formatarDataComHora(validadeAte),
        };
        vincularPerfilUsuario(perfilUsuarioInsert);
    };

    //Verifica se um dado objeto é do tipo `PerfilUsuario`
    function isPerfilUsuario(data: any): data is PerfilUsuario {
        return data &&
            typeof data.idUsuario === 'number' &&
            typeof data.idPerfil === 'number' &&
            data.perfil !== undefined;
    }

    async function vincularPerfilUsuario(perfilUsuarioInsert: PerfilUsuarioInsert): Promise<void> {
        try {
            showLoader();
            const request = {
                data: perfilUsuarioInsert,
                headers: {
                    "Content-Type": "application/json",
                }
            };

            const response = await new RestUseCase(ENDPOINT_PERFIS + "/usuario")
                .Post_<ServiceOperationResult<PerfilUsuario>>(request);

            if (response.success && response.data !== null && isPerfilUsuario(response.data)) {
                const novoPerfil: PerfilUsuario = {
                    idUsuario: response.data.idUsuario,
                    idPerfil: response.data.idPerfil,
                    dataInicio: response.data.dataInicio,
                    dataFim: response.data.dataFim,
                    perfil: {
                        id: response.data.perfil.id,
                        descricao: response.data.perfil.descricao
                    }
                };

                setPerfisUsuario((prevPerfis) => [...prevPerfis, novoPerfil]);
                LimparFormVincularPerfil();

                showAlert({
                    show: true,
                    content: response.message || "Perfil vinculado com sucesso!",
                    color: "success",
                    time: 5000
                });
            } else {
                showAlert({
                    show: true,
                    content: response.message || "Erro ao processar o perfil",
                    color: "danger",
                    time: 5000
                });
            }
            hideLoader();
        } catch (error) {
            console.error("Erro ao vincular perfil:", error);
            showAlert({
                show: true,
                content: "Erro inesperado ao vincular perfil",
                color: "danger",
                time: 5000
            });
            hideLoader();
        }
    }

    // Função para excluir o vínculo
    const excluirVinculo = (idPerfil: number) => {
        const perfilParaExcluir = perfisUsuario.find(perfil => perfil.idPerfil === idPerfil);
        //chamar o método para excluir o perfil do usuário
        if (perfilParaExcluir && perfilParaExcluir.idUsuario !== undefined && perfilParaExcluir.idPerfil !== undefined) {
            excluirPerfilUsuario(perfilParaExcluir.idUsuario, perfilParaExcluir.idPerfil)
                .then(() => {
                    console.info("Perfil excluído com sucesso.");
                })
                .catch(error => {
                    console.error("Erro ao excluir perfil:", error);
                });
        } else {
            console.warn("Perfil não encontrado ou com dados inválidos.");
        }
    };

    async function excluirPerfilUsuario(idUsuario: number, idPerfil: number): Promise<void> {
        const query = `/usuario/${idUsuario}/perfil/${idPerfil}`;

        try {
            showLoader();
            // Criando um objeto de request para enviar no DELETE
            const request = {
                data: null,
                headers: {}
            };

            const response = await new RestUseCase(ENDPOINT_PERFIS + query).Delete_<ServiceOperationResult<void>>(request);

            if (response.success) {
                showAlert({
                    show: response.success,
                    content: response.message,
                    color: "success",
                    time: 5000
                });
                const novaListaPerfis = perfisUsuario.filter(perfil => perfil.idPerfil !== idPerfil);
                setPerfisUsuario(novaListaPerfis);
            } else {
                console.error("Erro ao excluir perfil:", response.errors);
                showAlert({
                    show: true,
                    content: response.message || "Erro ao desvincular o perfil.",
                    color: "danger",
                    time: 5000
                });
            }
            hideLoader();
        } catch (error) {
            console.error("Erro ao excluir perfil:", error);
            showAlert({
                show: true,
                content: "Ops!!! Algo deu errado, tente novamente mais tarde...",
                color: "danger",
                time: 5000
            });
            hideLoader();
        }
    }

    const LimparFormVincularPerfil = () => {
        setPerfilSelecionado(null);
        setValidadeAte(null);
        setValidadeDe(null)
    };

    const FormVincularPerfil = () => {
        return (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <tbody>
                    <tr>
                        <td style={{ width: "50%", border: "none" }}>
                            <CompaniesListFull />
                        </td>
                        <td style={{ width: "50%", border: "none", padding: "8px" }}>
                            <LoginText />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "50%", border: "none" }}>
                            <NomeText />
                        </td>
                        <td style={{ width: "50%", border: "none", padding: "8px" }}>
                            <ProfileList />
                        </td>
                    </tr>
                    <tr>
                        <td style={{ width: "50%", border: "none", padding: "8px" }}>
                            <Row>
                                <Col>
                                    <Form.Group controlId="validadeDe">
                                        <Form.Label>Validade de:</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={validadeDe ?? ""}
                                            onChange={(e) => setValidadeDe(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                                <Col>
                                    <Form.Group controlId="validadeAte">
                                        <Form.Label>Validade até:</Form.Label>
                                        <Form.Control
                                            type="date"
                                            value={validadeAte ?? ""}
                                            onChange={(e) => setValidadeAte(e.target.value)}
                                        />
                                    </Form.Group>
                                </Col>
                            </Row>
                        </td>
                        <td style={{ width: "50%", border: "none", padding: "8px" }}>
                            <div style={{ textAlign: "left", marginTop: "34px" }}>
                                <Button variant="primary" size="sm" onClick={handleVincular}>
                                    Vincular
                                </Button>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        );
    };

    const TabUsuarioModeloClonar = () => {
        if (!usuariosEncontrados.length) return null;

        return (
            <div style={{ padding: "8px" }}>
                <Table striped bordered hover responsive size="sm">
                    <thead>
                        <tr>
                            <th className="text-center">Nome</th>
                            <th className="text-center">Email</th>
                            <th className="text-center">Login</th>
                            <th className="text-center">Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {usuariosEncontrados.map((usuario) => (
                            <tr key={usuario.id}>
                                <td>{usuario.nome}</td>
                                <td>{usuario.email}</td>
                                <td className="text-center">{usuario.login}</td>
                                <td className="text-center">
                                    <Button
                                        variant="primary"
                                        size="sm"
                                        onClick={() => OnClickEfetivarClonagem(usuario.id)}
                                    >
                                        Clonar
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
            </div>
        );
    };

    const FormClonarPerfil = () => {
        return (
            <Card>
                <Card.Header>Dados para Clonagem:</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6}>
                            <CompaniesListClonarPerfil />
                        </Col>
                        <Col md={6}>
                            <InputBuscarUsuario />
                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        )
    }

    const FormRestricoes = () => {
        return (
            <div>
                <Row>
                    <Col md={6}>
                        <Form.Label>Módulo:</Form.Label>
                        <Select
                            value={moduloSelecionado}
                            onChange={handleModuloChange}
                            options={modulos.map(modulo => ({ value: modulo.id, label: modulo.descricao }))}
                            placeholder="Selecione um módulo"
                            isClearable
                        />
                    </Col>
                    <Col md={6}>
                        <Form.Label>Objeto:</Form.Label>
                        <Select
                            value={objetoSelecionado}
                            onChange={(selectedOption) => setObjetoSelecionado(selectedOption)}
                            options={objetos.map(obj => ({ value: obj.id, label: obj.descricao }))}
                            placeholder="Selecione um objeto"
                            isClearable
                            isDisabled={!moduloSelecionado}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={12}>
                        <Form.Label>Permissões:</Form.Label>
                    </Col>
                    <Col md={3}>
                        <Form.Check
                            type="checkbox"
                            label="Incluir"
                            checked={incluir}
                            onChange={(e) => setIncluir(e.target.checked)}
                        />
                    </Col>
                    <Col md={3}>
                        <Form.Check
                            type="checkbox"
                            label="Alterar"
                            checked={alterar}
                            onChange={(e) => setAlterar(e.target.checked)}
                        />
                    </Col>
                    <Col md={3}>
                        <Form.Check
                            type="checkbox"
                            label="Consultar"
                            checked={consultar}
                            onChange={(e) => setConsultar(e.target.checked)}
                        />
                    </Col>
                    <Col md={3}>
                        <Form.Check
                            type="checkbox"
                            label="Excluir"
                            checked={excluir}
                            onChange={(e) => setExcluir(e.target.checked)}
                        />
                    </Col>
                </Row>
                <Row className="mt-3">
                    <Col md={12}>
                        <Button
                            variant="primary"
                            size="sm"
                            onClick={handleAdicionarRestricao}
                            disabled={!objetoSelecionado || !moduloSelecionado}
                        >
                            Adicionar Restrição
                        </Button>
                    </Col>
                </Row>
                <br />
                <br />
            </div>
        )
    }

    const RestricoesUsuarioList = () => {
        return (
            <TableHeaderFixedStyled>
                <Table>
                    <thead>
                        <tr>
                            <th>Módulo</th>
                            <th>Objeto</th>
                            <th>Incluir</th>
                            <th>Alterar</th>
                            <th>Consultar</th>
                            <th>Excluir</th>
                            <th style={{ width: '100px' }}>Ações</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoadingRestricoes ? (
                            <tr>
                                <td colSpan={7} className="text-center">Carregando...</td>
                            </tr>
                        ) : restricoesUsuario.length === 0 ? (
                            <tr>
                                <td colSpan={7} className="text-center">Nenhuma restrição cadastrada</td>
                            </tr>
                        ) : (
                            restricoesUsuario.map((restricao, index) => (
                                <tr key={restricao.id || index}>
                                    <td>{restricao.moduloDescricao || 'N/A'}</td>
                                    <td>{restricao.objetoDescricao || 'N/A'}</td>
                                    <td>{restricao.incluir ? 'Sim' : 'Não'}</td>
                                    <td>{restricao.alterar ? 'Sim' : 'Não'}</td>
                                    <td>{restricao.consultar ? 'Sim' : 'Não'}</td>
                                    <td>{restricao.excluir ? 'Sim' : 'Não'}</td>
                                    <td>
                                        <Button
                                            variant='danger'
                                            size='sm'
                                            onClick={() => handleRemoverRestricao(restricao.id)}
                                        >
                                            Excluir
                                        </Button>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </TableHeaderFixedStyled>
        )
    }

    const PerfisUsuarioList = () => {
        return (
            <div className="w-full">
                <table className="w-full text-sm border-collapse">
                    <thead className="sr-only">
                        <tr>
                            <th>Descrição</th>
                            <th className="text-center">Início</th>
                            <th className="text-center">Fim</th>
                            <th className="text-center">Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {perfisUsuario.map((perfil) => (
                            <tr key={perfil.idPerfil} className="border-b border-gray-100 hover:bg-gray-50">
                                <td className="py-2 pl-2 pr-4 text-left min-w-[120px]">
                                    {perfil.perfil.descricao}
                                </td>
                                <td className="py-2 px-3 text-center whitespace-nowrap">
                                    {formatDate(perfil.dataInicio)}
                                </td>
                                <td className="py-2 px-3 text-center whitespace-nowrap">
                                    {perfil.dataFim ? formatDate(perfil.dataFim) : "Indeterminado"}
                                </td>
                                <td className="py-2 px-3 text-center">
                                    <div className="inline-block">
                                        <AiOutlineDelete
                                            onClick={() => excluirVinculo(perfil.idPerfil)}
                                            style={{
                                                color: "#b91c1c",
                                                cursor: "pointer",
                                                transition: "color 0.2s ease",
                                            }}
                                            onMouseOver={(e) => (e.currentTarget.style.color = "#ef4444")}
                                            onMouseOut={(e) => (e.currentTarget.style.color = "#b91c1c")}
                                            size={16}
                                            title="Excluir"
                                        />
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    };

    /**
     *
     * LOGS DE USUARIO NA MODAL
     *
     */
    const ContainerTableCollapse = () => {

        const [openTableCollapse, updateOpenCollapse] = useState(false)

        const [dateInitial, updateDateInitial] = useState<string>()
        const [dateEnd, updateDateEnd] = useState<string>()

        function changeDateInitial(date: string) {
            updateDateInitial(date)
        }
        function changeDateEnd(date: string) {
            updateDateEnd(date)
        }

        const [listLogUser, updateListLogUser] = useState<any[]>([])

        const list = async (dateIni: string, dateEnd: string,) => {
            const list = await modelMethods.handleListLogUser(dateIni, dateEnd)

            if (list.statusCode === 200) {
                updateListLogUser(list.body)
            }
        }

        return (
            <>
                <Container>
                    <Row className="mt-3 align-items-center">
                        {/* Coluna esquerda */}
                        <Col>
                            <Button
                                onClick={() => {
                                    updateOpenCollapse(!openTableCollapse);
                                }}
                                aria-controls="example-collapse-text"
                                aria-expanded={openTableCollapse}
                                size="sm"
                                variant="outline-primary"
                            >
                                Ver Log de Acesso
                            </Button>

                            {inEditing && (
                                <Button
                                    onClick={openModalRestricoes}
                                    size="sm"
                                    variant="outline-primary"
                                    className="ms-2"
                                >
                                    Restrições
                                </Button>
                            )}
                        </Col>

                        {/* Coluna direita com botões agrupados */}
                        <Col className="text-end">
                            {canManagePurchaseLinks && <VinculosCompraBotao onClick={() => updateShowVinculos(true)} />}
                            <Button
                                variant="outline-success"
                                className="btn-custom me-2"
                                size="sm"
                                onClick={clonarPerfil}
                            >
                                Clonar Perfil
                            </Button>

                            <Button
                                variant="outline-primary"
                                className="btn-custom"
                                size="sm"
                                onClick={vincularPerfil}
                            >
                                Vincular Perfil
                            </Button>
                        </Col>
                    </Row>
                </Container>


                <Container>
                    <Collapse in={openTableCollapse}>
                        <div id="example-collapse-text">

                            <Row className="my-3">
                                <Col md={3}>
                                    <Form.Label>Início:</Form.Label>
                                    <Col>
                                        <Form.Control type="date" onChange={(event) => changeDateInitial(event.target.value)} />
                                    </Col>
                                </Col>
                                <Col md={3}>
                                    <Form.Label>Fim:</Form.Label>
                                    <Col>
                                        <Form.Control type="date" onChange={(event) => changeDateEnd(event.target.value)} />
                                    </Col>
                                </Col>
                            </Row>
                            <div className='d-flex align-items-center justify-content-end mt-4'>
                                <Button variant="primary" size="sm" className='mb-4' onClick={async () => {
                                    if (dateInitial && dateEnd) {
                                        await list(dateInitial, dateEnd)
                                        updateOpenCollapse(true)
                                    }
                                }}>Pesquisar</Button>
                            </div>

                            <TableHeaderFixedStyled>
                                <Table>
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Usuário</th>
                                            <th>Data/Hora</th>
                                            <th>Action</th>
                                            <th>IP</th>
                                            <th>Session</th>
                                            <th>Objeto</th>
                                            <th>Método</th>
                                            <th>Response Code</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {listLogUser.map((value, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>{value.id}</td>
                                                    <td>{value.usuario}</td>
                                                    <td>{value.data ? ParseDateToBrWithHours(value.data).replace(",", "") : ""}</td>
                                                    <td>{value.action}</td>
                                                    <td>{value.ip}</td>
                                                    <td>{value.session}</td>
                                                    <td>{value.objeto}</td>
                                                    <td>{value.metodo}</td>
                                                    <td>{value.responsecode}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </Table>
                            </TableHeaderFixedStyled>
                        </div>
                    </Collapse>
                </Container>
            </>
        )
    }

    // Funções para modal de restrições
    const openModalRestricoes = () => {
        setShowModalRestricoes(true);
        fetchModulos();
        fetchRestricoesUsuario();
        // Limpar seleções
        setModuloSelecionado(null);
        setObjetoSelecionado(null);
        setObjetos([]);
    }

    const closeModalRestricoes = () => {
        setShowModalRestricoes(false);
        setModuloSelecionado(null);
        setObjetoSelecionado(null);
        setIncluir(false);
        setAlterar(false);
        setConsultar(false);
        setExcluir(false);
        setObjetos([]);
    }

    const fetchModulos = async () => {
        try {
            const response = await new RestUseCase('/seguranca/modulos').Get().finally();
            if (response.body) {
                setModulos(response.body);
            }
        } catch (error) {
            console.error('Erro ao carregar módulos:', error);
        }
    }

    const fetchObjetos = async (moduloId: number) => {
        try {
            const response = await new RestUseCase(`/seguranca/modulos/${moduloId}/objetos`).Get().finally();
            if (response.body) {
                setObjetos(response.body);
            }
        } catch (error) {
            console.error('Erro ao carregar objetos:', error);
        }
    }

    const handleModuloChange = (selectedOption: any) => {
        setModuloSelecionado(selectedOption);
        setObjetoSelecionado(null); // Limpar objeto selecionado quando mudar o módulo
        if (selectedOption) {
            fetchObjetos(selectedOption.value);
        } else {
            setObjetos([]); // Limpar objetos se nenhum módulo estiver selecionado
        }
    }

    const fetchRestricoesUsuario = async () => {
        const userId = searchEntityId();
        if (!userId) return;

        setIsLoadingRestricoes(true);
        try {
            const response = await new RestUseCase(`/seguranca/usuario/${userId}/usuario-restricoes`).Get().finally();
            if (response.body) {
                setRestricoesUsuario(response.body);
            }
        } catch (error) {
            console.error('Erro ao carregar restrições do usuário:', error);
        } finally {
            setIsLoadingRestricoes(false);
        }
    }

    const handleAdicionarRestricao = async () => {
        const userId = searchEntityId();
        if (!userId || !objetoSelecionado || !moduloSelecionado) return;

        try {
            const restricaoData = {
                objetoIds: [objetoSelecionado.value],
                incluir: incluir ? 1 : 0,
                alterar: alterar ? 1 : 0,
                consultar: consultar ? 1 : 0,
                excluir: excluir ? 1 : 0
            };

            const response = await new RestUseCase(`/seguranca/usuario/${userId}/usuario-restricoes`).Post({ data: restricaoData }).finally();

            if (response.statusCode >= 200 && response.statusCode < 300) {
                showAlert({
                    show: true,
                    content: 'Restrição adicionada com sucesso!',
                    color: 'success',
                    time: 2000,
                });
                await fetchRestricoesUsuario();
                setObjetoSelecionado(null);
                setIncluir(false);
                setAlterar(false);
                setConsultar(false);
                setExcluir(false);
            } else {
                showAlert({
                    show: true,
                    content: 'Erro ao adicionar restrição.',
                    color: 'danger',
                    time: 2000,
                });
            }
        } catch (error) {
            showAlert({
                show: true,
                content: 'Erro ao processar operação.',
                color: 'danger',
                time: 2000,
            });
        }
    }

    const handleRemoverRestricao = async (restricaoId: number) => {
        const userId = searchEntityId();
        if (!userId) return;

        try {
            const response = await new RestUseCase(`/seguranca/usuario/${userId}/usuario-restricoes/${restricaoId}`).Delete().finally();

            if (response.statusCode === 204) {
                showAlert({
                    show: true,
                    content: 'Restrição removida com sucesso!',
                    color: 'success',
                    time: 2000,
                });
                await fetchRestricoesUsuario();
            } else {
                showAlert({
                    show: true,
                    content: 'Erro ao remover restrição.',
                    color: 'danger',
                    time: 2000,
                });
            }
        } catch (error) {
            showAlert({
                show: true,
                content: 'Erro ao processar operação.',
                color: 'danger',
                time: 2000,
            });
        }
    }

    /**
     *
     * RENDER
     *
     */
    return (
        loading ?
            <Loading />
            :
            <>
                <HeaderCrud title={titlePage} >
                    <div>
                        <Button variant="primary" size="sm" onClick={() => { onClickNew() }}>
                            Novo
                        </Button>
                    </div>
                </HeaderCrud>
                <div className="mx-2">
                    <Card>
                        <Card.Body>
                            <CompaniesList />
                            <CreateTableCrud tableHeader={tableComponents.tableHeader} tableBody={tableComponents.tableBody} entityFields={entity} openModalCrud={onClickTable} />
                        </Card.Body>
                    </Card>
                </div>
                <Footer />

                <ModalCrud title={titlePage} open={openModalCrud} close={closeModalCrud} isOpen={showModalCrud} isEditing={inEditing} submit={onSubmitForm}>
                    <div>
                        <CreateFieldModalCrud entityFields={entityFields} changeField={changeField} inEditing={inEditing} />

                        {
                            <>
                                <Row className="mt-3 mb-3">
                                    <Form.Label>Perfis:</Form.Label>
                                    {
                                        checkboxValues.map((checkboxValue: string, index) => {
                                            return (
                                                <Col key={index} md={3}>
                                                    <Form.Check label={checkboxValue.replaceAll("_", " ")} type="checkbox" value={checkboxValue} checked={checkedState[index]} onChange={(e) => { addRemoveProfile(e, index) }} />
                                                </Col>
                                            )
                                        })

                                    }
                                </Row>
                                {inEditing ?
                                    <Row>
                                        <ContainerTableCollapse />
                                    </Row>
                                    :
                                    <>
                                    </>
                                }
                            </>
                        }
                    </div>
                    <div>
                        {!inEditing ? <Button variant="primary" size="sm" type="submit">Salvar</Button> : <></>}
                        {inEditing ? <Button variant="primary" size="sm" onClick={onEditUser}>Salvar</Button> : <></>}
                        {inEditing ? <Button className="ms-1" variant="outline-primary" size="sm" onClick={onPasswordReset}>Redefinição de Senha</Button> : <></>}
                        {inEditing ? searchEntityStatus() === "B" ? <Button className="ms-1" variant="success" size="sm" onClick={unblockUser}>Desbloquear</Button> :
                            <Button className="ms-1" variant="danger" size="sm" onClick={blockUser}>Bloquear</Button> : <></>}
                    </div>
                </ModalCrud>

                {/* Modal Vínculos de compra */}
                {canManagePurchaseLinks && inEditing && (
                    <VinculosCompraModal
                        idUsuario={searchEntityId()}
                        idEmpresa={companyID}
                        show={showVinculos}
                        onHide={() => updateShowVinculos(false)}
                    />
                )}

                {/* Modal Vincular Perfil */}
                <Modal show={showModalVincularPerfil} onHide={closeModalVincularPerfil} size="xl" fullscreen="md-down">
                    <Modal.Header closeButton>
                        <Modal.Title className="ms-3 lead" style={{ fontSize: "30px" }}>
                            Vinculo de Perfis
                        </Modal.Title>
                    </Modal.Header>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            onSubmitForm();
                        }}
                        className="mt-0"
                        noValidate
                    >
                        <Modal.Body>
                            <div style={{ padding: "2px" }}>
                                <FormVincularPerfil />
                                <Card>
                                    <Card.Header>Perfis Vinculados:</Card.Header>
                                    <Card.Body>
                                        <PerfisUsuarioList />
                                    </Card.Body>
                                </Card>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginTop: "10px" }}>
                                <Button variant="danger" size="sm" onClick={closeModalVincularPerfil}>
                                    Sair
                                </Button>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>


                {/* Modal Clonar Perfil */}
                <Modal show={showModalClonarPerfil} onHide={closeModalClonarPerfil} size="xl" fullscreen="md-down">
                    <Modal.Header closeButton>
                        <Modal.Title className="ms-3 lead" style={{ fontSize: "30px" }}>
                            Clonar Perfil
                        </Modal.Title>
                    </Modal.Header>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            onSubmitForm();
                        }}
                        className="mt-0"
                        noValidate
                    >
                        <Modal.Body>
                            <div style={{ padding: "2px" }}>
                                <FormClonarPerfil />
                                <FormRestricoes />
                            </div>
                            <div style={{ padding: "2px" }}>
                                <TabUsuarioModeloClonar />
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginTop: "10px" }}>
                                <Button variant="danger" size="sm" onClick={closeModalClonarPerfil}>
                                    Sair
                                </Button>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>

                {/* Modal Restrições */}
                <Modal show={showModalRestricoes} onHide={closeModalRestricoes} size="xl" fullscreen="md-down">
                    <Modal.Header closeButton>
                        <Modal.Title className="ms-3 lead" style={{ fontSize: "30px" }}>
                            Restrições do Usuário
                        </Modal.Title>
                    </Modal.Header>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                        }}
                        className="mt-0"
                        noValidate
                    >
                        <Modal.Body>
                            <div style={{ padding: "2px" }}>
                                <FormRestricoes />
                                <Card>
                                    <Card.Header>Restrições Cadastradas:</Card.Header>
                                    <Card.Body>
                                        <RestricoesUsuarioList />
                                    </Card.Body>
                                </Card>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div style={{ display: "flex", justifyContent: "flex-start", gap: "10px", marginTop: "10px" }}>
                                <Button variant="danger" size="sm" onClick={closeModalRestricoes}>
                                    Sair
                                </Button>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>


            </>
    )

}

export default UserPageV2
